import { Component, Input } from '@angular/core';
import { BaseModalComponent } from '../base-modal/base-modal.component';

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    standalone: false
})
export class ConfirmationModalComponent extends BaseModalComponent {

  @Input() message!: string;

}
